/* eslint-disable import/first */
import React, { Suspense, useState, lazy, useEffect } from "react";
import _ from "lodash";
import { Redirect } from "react-router";
import { Route, Switch } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";

// Assets
import styles from "./navigation-style";
const useStyles = makeStyles(styles);

// Pages
const Home = lazy(() => import("../home/Home.js"));

const Navigation = (props) => {
	const classes = useStyles(props);

	const paths = {
		home: "/",
	};

	return (
		<div className={classes.root}>
			<Suspense fallback={<div />}>
				<Switch>
					<Route path={paths.home} component={Home} />
					<Route path="*" render={() => <Redirect to="/" />} />
				</Switch>
			</Suspense>
		</div>
	);
};

export default Navigation;
